import "./PantryStackLogoCss.css";

interface PantryStackLogoProps {
  ShowName?: boolean;
  Inverse?: boolean;
  Compact?: boolean;
}

export default function PantryStackLogo({
  ShowName = true,
  Inverse = false,
  Compact = false,
}: PantryStackLogoProps) {
  return (
    <div
      className={`pantrystack-logo ${Inverse ? "pantrystack-logo-inverse" : ""} ${Compact ? "pantrystack-logo-compact" : ""}`}
      aria-label="PantryStack"
    >
      <svg viewBox="0 0 72 72" role="img" aria-hidden="true">
        <path
          d="M12 10h25c14 0 23 7 23 19 0 13-10 20-24 20H25v13H12V10Zm13 11v17h11c7 0 11-3 11-9 0-5-4-8-11-8H25Z"
          fill="currentColor"
        />
        <path
          d="M54 25c-4-4-9-6-15-6-5 0-8 2-8 5 0 4 4 5 11 7 11 3 18 7 18 16 0 11-9 17-22 17-10 0-19-3-26-10l8-9c5 5 11 8 18 8 6 0 9-2 9-6 0-3-4-5-12-7-10-3-17-7-17-16 0-10 8-16 21-16 9 0 16 3 22 8l-7 9Z"
          fill="currentColor"
          opacity="0.72"
        />
      </svg>
      {ShowName && (
        <span>
          PantryStack
          {!Compact && <small>ADMIN</small>}
        </span>
      )}
    </div>
  );
}
